import React, { FC } from "react";
import { CartProps } from "./Cart";
import { HeaderLeft } from "./HeaderLeft";
import { HeaderRight } from "./HeaderRight";
import { LocationProps } from "./Location";
import { LogoProps } from "./Logo";
import { SearchBarProps } from "./Search";
import { SubNav, SubNavItem } from "./SubNav";
import { UserProps } from "./User";
import {
  StyledHeader,
  StyledHeaderLeft,
  StyledHeaderRight,
  StyledPromo,
  StyledWrapper,
} from "./index.styled";
import { NavLinksProps } from "./NavMenu";

// Re-export types for consumers of @pepdirect/v3/ui/NavHeader
export type { CartProps } from "./Cart";
export type { LocationProps } from "./Location";
export type { LogoProps } from "./Logo";
export type { NavLinksProps } from "./NavMenu";
export type { SearchBarProps } from "./Search";
export type { UserProps } from "./User";

export interface HeaderProps {
  accountAsNavLink?: boolean;
  authUsersOnly?: boolean;
  location?: LocationProps;
  logo: LogoProps;
  navLinks: NavLinksProps;
  promotion: {
    promotionText: string;
    shouldShow: boolean;
  };
  searchBar?: SearchBarProps;
  cart?: CartProps;
  subNav?: SubNavItem[];
  user: UserProps;
}

export const NavHeader: FC<HeaderProps> = ({
  accountAsNavLink,
  authUsersOnly,
  location,
  logo,
  navLinks,
  promotion,
  searchBar,
  cart,
  subNav,
  user,
}) => {
  return (
    <StyledHeader>
      {promotion.shouldShow && (
        <StyledPromo data-testid="ui-header-promo">
          {promotion.promotionText}
        </StyledPromo>
      )}

      <StyledWrapper showPromo={promotion.shouldShow}>
        <StyledHeaderLeft>
          <HeaderLeft
            accountAsNavLink={accountAsNavLink}
            location={location}
            logo={logo}
            navLinks={navLinks}
            subNav={subNav}
            user={user}
          />
        </StyledHeaderLeft>

        <StyledHeaderRight>
          <HeaderRight
            accountAsNavLink={accountAsNavLink}
            authUsersOnly={authUsersOnly}
            location={location}
            searchBar={searchBar}
            cart={cart}
            user={user}
          />
        </StyledHeaderRight>
      </StyledWrapper>

      {!!subNav?.length && <SubNav subNav={subNav} />}
    </StyledHeader>
  );
};
